module.exports = __webpack_public_path__ + "img/place22.48423030.jpg";